var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 8.04C8.62 8.04 8.28 8.19 8.02 8.425L4.455 6.35C4.48 6.235 4.5 6.12 4.5 6C4.5 5.88 4.48 5.765 4.455 5.65L7.98 3.595C8.25 3.845 8.605 4 9 4C9.83 4 10.5 3.33 10.5 2.5C10.5 1.67 9.83 1 9 1C8.17 1 7.5 1.67 7.5 2.5C7.5 2.62 7.52 2.735 7.545 2.85L4.02 4.905C3.75 4.655 3.395 4.5 3 4.5C2.17 4.5 1.5 5.17 1.5 6C1.5 6.83 2.17 7.5 3 7.5C3.395 7.5 3.75 7.345 4.02 7.095L7.58 9.175C7.555 9.28 7.54 9.39 7.54 9.5C7.54 10.305 8.195 10.96 9 10.96C9.805 10.96 10.46 10.305 10.46 9.5C10.46 8.695 9.805 8.04 9 8.04Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.14f8e494e015f09c030b075e02a2b98e.svg";
export { ForwardRef as ReactComponent };